type PublicClientEvent = "client_error" | "promise_rejection" | "layout_overflow" | "form_abandoned";

export function reportClientEvent(type: PublicClientEvent) {
  const body = JSON.stringify({
    type,
    path: `${location.pathname}${location.search}`.slice(0, 240),
    viewport: { width: innerWidth, height: innerHeight },
    online: navigator.onLine,
  });
  void fetch("/api/v1/public/client-events", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => undefined);
}

export function startClientTelemetry() {
  addEventListener("error", () => reportClientEvent("client_error"));
  addEventListener("unhandledrejection", () => reportClientEvent("promise_rejection"));
  const inspect = () => {
    if (document.documentElement.scrollWidth > innerWidth + 2) reportClientEvent("layout_overflow");
  };
  addEventListener("load", inspect, { once: true });
  addEventListener("resize", inspect, { passive: true });
}
